
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import FaqSection from "@/components/FaqSection.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getServiceJsonLd } from "@/utils/seo";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb,
    FaqSection
  }
})
export default class epm extends Vue {
  // FAQ 数据
  faqList = [
    { question: "EPM企业绩效系统是什么？", answer: "光华EPM企业绩效系统是以绩效飞轮®为底座的企业绩效管理平台，涵盖绩效管理、基础人事、主线作业流程、经营性财务、KM与ELN、CRM销售管理六大模块。" },
    { question: "EPM系统适合什么企业？", answer: "适合希望实现绩效管理数字化、提升组织效率的成长型企业，尤其适合需要从战略到执行全流程管理的中大型企业。" },
    { question: "EPM系统如何帮助企业？", answer: "通过绩效飞轮方法论+数字化系统，帮助企业将战略转化为每个人的日常工作，实现目标对齐、过程管理、结果评估的闭环管理。" }
  ];
  get metaInfo() {
    return generateMetaInfo({
      title: "EPM企业绩效系统 | 以绩效飞轮®为底座的企业绩效管理平台 - 光华赋能",
      description:
        "光华EPM企业绩效系统，以绩效飞轮®为底座，涵盖绩效管理、基础人事、主线作业流程、经营性财务、KM与ELN、CRM销售管理六大模块，帮助企业实现数字化绩效管理。",
      keywords:
        "EPM,企业绩效系统,绩效管理系统,绩效飞轮,人事管理,CRM,企业数字化,光华赋能",
      path: "/epm",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "数字化" },
        { name: "EPM企业绩效系统" }
      ],
      jsonLd: getServiceJsonLd({
        name: "EPM企业绩效系统",
        description:
          "以绩效飞轮为底座的企业绩效管理平台，涵盖绩效管理、人事、流程、财务、KM、CRM等模块。",
        category: "企业绩效管理软件"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/62307d0e502a0fe322ff1113bc3f019b.png";
  pic2 = "/img/dc75181d42761ba0169ae86d30e3712d.png";
  pic3 = "/img/bb3209a58159ccf01434dfd23db3669e.png";
  pic4 = "/img/aa3f9d3cc67b42c8e2264c50e660ec88.png";
  pic5 = "/img/0c1ca0ff9fe0098b2667a27c96cb0821.png";
  pic6 = "/img/8b5351f3338eb973e18381f83464cfce.png";
  pic7 = "/img/23abfac16788737fd7fc0a44bd4b50e6.png";
  List = [
    { title: "数字化", url: "" },
    { title: "EPM企业绩效系统", url: "" }
  ];
  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "数字化方案陪跑，EPM企业绩效系统，绩效飞轮，ELP，微学，光华商学"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "专家，落地指导，规划，战略到执行，数字化转型方案，数字化，转型，数字化+，+数字化，数字化管理体系，业务转型，效率提升，持续增长，底层框架 ,全盘规划,从战略到执行全流程,过程,落地,问题,目标,调研,诊断,成果,复盘,赛道分析,企业位置,行业趋势,企业现状营收、盈利、规模、定位、生态位、战略控制点、价值主张,组织与人才,人才、组织盘点,结构、员工数,管理体系机制、制度、流程（尤其是业务主流程）、股权,差距分析,机会差距,业绩差距,三找,找差距、找不满、,找原因,梳理核心问题,对标对标杆,对历史数据,对BLM,目标共识,FCIL四个角度,企业培训,海量课程库，阶段目录，有序学习，要点检测，成果考核，加深理解，记忆实践，巧用关联，灵活使用，学，考，练，用，个人学习，缺乏体系，员工提升，管理层、电商、营销等不同团队缺乏专属课程资源，无法进行精准的专项培训，人才培养效率低下，因学习资源与培训体系不完善，导致关键岗位的能力成长缓慢，业务发展受到制约，人才培养的滞后，最终成为企业创新与增长步伐的瓶颈，实力名师，体系化学习，结构化知识体系，精品课，试听"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
